<ng-container *ngIf="isAnalog">
    <app-channel-alarm-form
        *ngFor="let form of ANALOG_ALARM_FORMS"
        class="alarm-form-container"
        [panelTitle]="form.panelTitle"
        [property]="form.property"
        [selectedChannel]="newChannel"
        [toggleDisabled]="isToggleDisabled(form)"
        (onChannelChange)="onChannelChange.emit($event)"
        (onFocusChange)="onFocusChange.emit()"></app-channel-alarm-form>
</ng-container>

<ng-container *ngIf="isExhGasDev">
    <app-channel-alarm-form
        *ngFor="let form of EXH_GAS_DEV_ALARM_FORMS"
        class="alarm-form-container"
        [panelTitle]="form.panelTitle"
        [property]="form.property"
        [selectedChannel]="newChannel"
        [toggleDisabled]="isToggleDisabled(form)"
        (onChannelChange)="onChannelChange.emit($event)"
        (onFocusChange)="onFocusChange.emit()"></app-channel-alarm-form>
</ng-container>

<ng-container *ngIf="isExhGasMean">
    <app-channel-alarm-form
        *ngFor="let form of EXH_GAS_MEAN_ALARM_FORMS"
        class="alarm-form-container"
        [panelTitle]="form.panelTitle"
        [property]="form.property"
        [selectedChannel]="newChannel"
        [setPointOnly]="true"
        (onChannelChange)="onChannelChange.emit($event)"
        (onFocusChange)="onFocusChange.emit()"></app-channel-alarm-form>
</ng-container>

<ng-container *ngIf="isRunning || isFlow">
    <app-channel-alarm-form
        *ngFor="let form of FLOW_RUNNING_ALARM_FORMS"
        class="alarm-form-container"
        [panelTitle]="form.panelTitle"
        [property]="form.property"
        [selectedChannel]="newChannel"
        [toggleDisabled]="isToggleDisabled(form)"
        (onChannelChange)="onChannelChange.emit($event)"
        (onFocusChange)="onFocusChange.emit()"></app-channel-alarm-form>
</ng-container>

<ng-container *ngIf="isDigitalMotor">
    <app-channel-alarm-form
        *ngFor="let form of MOTOR_ALARM_FORMS"
        class="alarm-form-container"
        [panelTitle]="form.panelTitle"
        [property]="form.property"
        [selectedChannel]="newChannel"
        (onChannelChange)="onChannelChange.emit($event)"
        (onFocusChange)="onFocusChange.emit()"></app-channel-alarm-form>
    <app-channel-alarm-form
        class="alarm-form-container motor-alarm-settings"
        panelTitle="channel.alarm.label.alarm-setting"
        property="motorChannelSetting"
        [selectedChannel]="newChannel"
        (onChannelChange)="onChannelChange.emit($event)"
        (onFocusChange)="onFocusChange.emit()"></app-channel-alarm-form>
</ng-container>
